/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'expenseCategories/insurance': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M12.81 1.173l7 3.11c.72.32 1.19 1.04 1.19 1.83v4.7c0 5.55-3.84 10.74-9 12-5.16-1.26-9-6.45-9-12v-4.7c0-.79.47-1.51 1.19-1.83l7-3.11c.51-.23 1.11-.23 1.62 0zM12 6a1 1 0 00-1 1v3H8a1 1 0 000 2h3v3a1 1 0 002 0v-3h3a1 1 0 000-2h-3V7a1 1 0 00-1-1z" _fill="#000" fill-rule="evenodd"/>'
  }
})
